import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export type StatusTone = "neutral" | "info" | "success" | "warning" | "danger" | "muted";

export interface StatusBadgeProps {
  tone: StatusTone;
  children: ReactNode;
}

// info/success/warning use raw Tailwind palette colours because the codebase's
// shadcn token set defines no --info/--success/--warning variables. Add them to
// globals.css and switch these tones over if the badge needs to follow themes.
const toneStyles: Record<StatusTone, string> = {
  neutral: "bg-secondary text-foreground",
  info: "bg-blue-100 text-blue-800",
  success: "bg-green-100 text-green-800",
  warning: "bg-amber-100 text-amber-800",
  danger: "bg-destructive/15 text-destructive",
  muted: "bg-muted text-muted-foreground",
};

export function StatusBadge({ tone, children }: StatusBadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium",
        toneStyles[tone],
      )}
    >
      {children}
    </span>
  );
}
